import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@4.3.0/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-amap",
  "use": "icon-amap-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-amap\">\n<style type=\"text/css\">\n\t#icon-amap .st0{fill:#0371C5;}\n\t#icon-amap .st1{fill:#059DFD;}\n\t#icon-amap .st2{fill:#0257A8;}\n</style>\n<polygon class=\"st0\" points=\"60.4,129 64.3,169.1 186.3,19.2 \" />\n<polygon class=\"st1\" points=\"147.4,180.8 91.4,146.5 64.3,169.1 75.1,134.9 75.2,134.9 75.3,134.7 184.5,22.1 60.4,129.1 60.4,129 \n\t14.3,99.2 186.3,19.2 \" />\n<polygon class=\"st2\" points=\"75.3,134.7 91.4,146.5 64.3,169.1 \" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/amap.svg
// module id = Ct1/
// module chunks = 3